<template>
  <div class="yhc-component YhcCheckbox" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>
    <div class="content">
      <el-checkbox-group v-model="result" @change="$_change">
        <el-checkbox
          style="margin-bottom: 8px"
          :key="index"
          v-for="(item, index) in labelCheckboxOptions"
          :label="item.value"
          :disabled="item.disabled"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin3 from './componentsData/methodsMixin3';

import PrivateLabel from './componentsData/PrivateLabel.vue';

let identifierName = 'YhcCheckbox';

export default {
  name: identifierName,

  components: { PrivateLabel },
  mixins: [propsMixin, methodsMixin3],

  data() {
    return {
      result: this.value || [],
    };
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
    labelCheckboxOptions: {
      type: Array,
      required: true,
    },
    // trueLabel: {
    //   type: [Number, String],
    // },
    // falseLabel: {
    //   type: [Number, String],
    // },
  },
  computed: {},
  watch: {
    value(newVal, oldVal) {
      this.result = newVal || [];
    },
  },
  methods: {},
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcCheckbox {
  @include labelCommon();
}
</style>
